import classNames from 'classnames';

import { SimpleBanner } from '@features/Paywall/components/simple-banner';
import { getDiscountTimer } from 'src/stores/legend';

import styles from './banner-section.module.css';

export type BannerSectionProps = {
  isHeader?: boolean;
  isHide?: boolean;
  initFooter?: boolean;
  onClick?: () => void;
  onFinish?: () => void;
  isNgrow?: boolean;
  className?: string;
};

export const BannerSection = ({
  isHeader = true,
  isHide = false,
  initFooter = false,
  onClick,
  onFinish,
  className,
}: BannerSectionProps) => {
  const sectionClassName = classNames(
    isHeader ? styles.headerSection : styles.footerSection,
    {
      [styles.hideHeader]: isHeader && isHide,
      [styles.hideFooter]: !isHeader && isHide,
      [styles.initFooter]: !isHeader && initFooter,
    },
    className,
  );

  return (
    <section className={sectionClassName}>
      <SimpleBanner
        onClick={onClick}
        onFinish={onFinish}
        targetTime={getDiscountTimer()}
      />
    </section>
  );
};
